/**
 * 描述：预览标题摘要指令
 * 日期：2017-08-08
 * 作者；Bai.Zhiming
 */
'use strict';
angular
    .module('trsPreviewTitleModule', [])
    .directive('previewTitle', [
        '$window',
        '$timeout',
        function($window, $timeout) {
            return {
                restrict: 'A',
                replace: false,
                transclude: true,
                scope: {
                    titleText: '=',
                    summaryText: '=',
                },

                /* template: '<div class="preview-title"><a class="limita" data-ng-bind-html="titleText"  ng-click="openTarget()" ng-class="{\'not-read\':notRead==0}"></a>' +
                 '<div class="panel panel-info extra-info" ng-show="extraInfoShow" ng-style="panelpostion"> ' +
                 '<div class="panel-heading" data-ng-bind-html="titleText" ng-hide="hideTitle"></div>' +
                 '<div class="panel-body word-wrap-break-word"><span class="text-red display-inline-block">{{summaryName}}：</span>{{summaryText||noSummaryText}}</div><div class="arrow" ng-style="arrowposition"><div></div></div>',*/
                link: function(scope, $elem, $attrs) {
                    $timeout(function() {
                        initStatus();
                    });

                    /**
                     * [initStatus description] 初始化状态
                     * @return {[type]} [description]
                     */
                    function initStatus() {
                        if (!scope.summaryText || scope.summaryText == 'null') {
                            return;
                        }
                        scope.status = {
                            showHover: false,
                        };
                        initElement();
                        initMouseEnter();
                        initMouseLeave();
                        initDestroy();
                    }

                    /**
                     * [initDestroy description] 初始化销毁事件
                     * @return {[type]} [description]
                     */
                    function initDestroy() {
                        scope.$on('$destroy', function() {
                            if (angular.isDefined(scope.status.$template)) {
                                scope.status.$template.remove();
                            }
                        });
                    }

                    /**
                     * [initElement description] 初始化容器样式
                     * @return {[type]} [description]
                     */
                    function initElement() {
                        $elem.css({ position: 'relative' });
                    }

                    /**
                     * [initMouseEnter description] 初始化鼠标移入
                     * @return {[type]} [description]
                     */
                    function initMouseEnter() {
                        $elem.bind('mouseenter', function() {
                            scope.status.$template = $(
                                [
                                    "<div class='previewTitle'>",
                                    '<div></div>',
                                    '<div>',
                                    $attrs.notabstract === 'true' ? '　　' : $attrs.notabstract === 'noIndent' ? '' : '<span>摘要：</span>',
                                    // "<span>" + scope.summaryText + "</span>",
                                    getSummaryTextTpl(scope.summaryText),
                                    '</div>',
                                    "<div class='arrow'> </div>",
                                    '<div>',
                                ].join('')
                            );
                            $('body').append(scope.status.$template);
                            CorrectDirection();
                        });
                    }

                    /**
                     * [getSummaryTextTpl 根据数据类型, 返回一个数据模板, 还是多个数据模板]
                     * @param  {[type]} tplData [渲染模板的数据]
                     * @return {[type]}         [description]
                     */
                    function getSummaryTextTpl(tplData) {
                        if (Object.prototype.toString.call(tplData) == '[object Array]') {
                            var tpl = [];
                            tplData.map(function(item) {
                                tpl.push('<span>' + item + '</span><br/>');
                            });
                            return tpl.join('');
                        } else {
                            return '<span>' + scope.summaryText + '</span>';
                        }
                    }

                    /**
                     * [initDirection description] 修正tip显示的方向 当向下显示空间不足时，自动向上显示
                     * @return {[type]} [description]
                     */
                    function CorrectDirection() {
                        var bodyHeight = $('body').height();
                        var parentHeight = $elem[0].offsetHeight;
                        var parentTop = $elem.offset().top;
                        var parentLeft = $elem.offset().left;
                        var parentWidth = $elem[0].offsetWidth;
                        if (!isNaN($attrs['customMaxWidth'])) {
                            // 自定义摘要宽度
                            scope.status.$template.css({ maxWidth: Number($attrs['customMaxWidth']) });
                        }
                        var templateWidth = scope.status.$template[0].offsetWidth;
                        var templateHeight = scope.status.$template[0].offsetHeight;
                        // if ((templateTop + templateHeight) > bodyHeight) {
                        scope.status.$template.css({ top: parentTop - templateHeight - 10, left: parentLeft });
                        scope.status.$template.find('.arrow').css({
                            transform: 'rotate(180deg)',
                            top: templateHeight,
                        });
                        if (templateHeight > parentTop - 60) {
                            // 上面放不下就放下面
                            scope.status.$template.css({ top: parentTop + parentHeight + 6, left: parentLeft });
                            if (templateHeight > bodyHeight - parentHeight - parentTop) {
                                // 下面也放不下就加宽
                                if (!isNaN($attrs['customMaxWidth'])) {
                                    // 自定义摘要宽度
                                    scope.status.$template.css({ maxWidth: Number($attrs['customMaxWidth']) });
                                }
                            }
                            scope.status.$template.find('.arrow').css({
                                transform: 'rotate(0deg)',
                                top: -6,
                            });
                        }

                        var templateRight = scope.status.$template[0].offsetLeft + templateWidth;
                        if (templateRight >= $('body').width()) {
                            // 右侧位置大于视窗宽时, 放置到左边
                            scope.status.$template.css({ left: parentLeft - templateWidth + parentWidth });
                            scope.status.$template.find('.arrow').css({ left: templateWidth - 12 });
                        }

                        /* } else {
                        var $arrow = scope.status.$template.find(".arrow");
                        var arrowHeight = $arrow[0].offsetHeight;
                        $arrow.css({ top: -arrowHeight });
                    }*/
                    }

                    /**
                     * [initMouseLeave description] 初始化鼠标移出
                     * @return {[type]} [description]
                     */
                    function initMouseLeave() {
                        $elem.bind('mouseleave', function() {
                            $('body')
                                .find('.previewTitle')
                                .remove();
                        });
                    }
                },
            };
        },
    ])
    .directive('previewTitleOnce', [
        '$window',
        function($window) {
            return {
                restrict: 'EA',
                replace: true,
                transclude: true,
                scope: {
                    titleText: '@ ',
                    targetUrl: '@',
                    summaryText: '@',
                    adjustPosition: '@',
                    notRead: '@',
                },
                template:
                    '<div class="preview-title" ><a class="limita" bindonce bo-html="titleText"  ng-click="openTarget()" bo-class="{\'not-read\':notRead==0}"></a>' +
                    '<div class="panel panel-info extra-info hidden" bindonce="panelpostion"  bo-style="panelpostion"> ' +
                    '<div class="panel-heading" bindonce bo-html="titleText"></div>' +
                    '<div class="panel-body"><span class="text-red">摘要：</span><span bindonce bo-text="summaryText"></div><div class="arrow"><div></div></div>',

                controller: function($scope, $element, $attrs) {
                    $scope.summaryText = $scope.summaryText == 'undefined' ? '' : $scope.summaryText;
                    $scope.noSummaryText = $attrs.noSummaryText ? $attrs.noSummaryText : '';
                    $scope.extraInfoShow = false;
                    $scope.openTarget = function() {
                        if ($scope.notRead || $scope.notRead == '') {
                            $scope.notRead = 1;
                        }
                        if ($scope.targetUrl) {
                            $window.open($scope.targetUrl);
                        }
                    };
                    $element.bind('mouseleave', function() {
                        $element.find('.extra-info')['addClass']('hidden');
                    });
                },
                link: function(scope, element, attrs, ctrl) {
                    var windowHt = $window.outerHeight,
                        elemTp = angular.element(element).offset().top,
                        elemHt = scope.summaryText && (scope.summaryText.length / 27) * 21 + 50;
                    element.bind('mouseenter', function(event) {
                        if (scope.adjustPosition == 'true') {
                            if (windowHt - elemTp > elemHt) {
                                scope.panelpostion = {
                                    left: event.offsetX,
                                };
                            } else {
                                scope.panelpostion = {
                                    left: event.offsetX,
                                    top: -elemHt,
                                };
                            }
                        } else {
                            scope.panelpostion = {
                                left: event.offsetX,
                            };
                        }
                        element.find('.extra-info')['removeClass']('hidden');
                    });
                },
            };
        },
    ]);
